import BaseDragLogic, { IMouseDownProps } from './base-drag-logic';

export class MobileBaseDragLogic extends BaseDragLogic {
    private isEditing?: boolean;

    /**
     * touch到元素上
     * @param event
     * @param element
     * @param scale
     */
    public handleTouchStartOnElement = (props: IMouseDownProps): void => {
        document.body.addEventListener('touchmove', this.handleTouchMove, { passive: false });
        document.body.addEventListener('touchend', this.handleDragStop);
        this.isEditing = props.isEditing;
        this.startDrag(props);
    };

    /**
     * 拖拽结束
     * @param event
     */
    private handleDragStop = (event: MouseEvent) => {
        document.body.removeEventListener('touchmove', this.handleTouchMove);
        document.body.removeEventListener('touchend', this.handleDragStop);
        this.stopDrag(event);
    };

    private handleTouchMove = (event) => {
        if (this.isEditing) return;
        event.preventDefault();
        event.stopPropagation();
        if (event?.touches?.length > 1) {
            return;
        }
        const delayTime = -1;
        this.handleMove(event, delayTime);
    };
}
